<jmkw-popout-button
  #unitConfigButton
  [iconName]="iconName"
  [contentComponent]="componentRef"
  [tooltipText]="tooltipText"
></jmkw-popout-button>
